module.exports = __webpack_public_path__ + "img/action-Reemitere PIN2.e27cf320.svg";